import type { ProductionTargetEnvironment } from "../types/environment";

export const productionEnvironments: ProductionTargetEnvironment[] = [
  "ha-production",
  "production",
];
